module.exports = __webpack_public_path__ + "img/address-icon.2223523a.png";